(function () {
  'use strict';

  function init(root) {
    root.querySelectorAll('[data-uc-product-gallery]').forEach(function (gallery) {
      if (gallery.dataset.ucGalleryReady === 'true') return;
      gallery.dataset.ucGalleryReady = 'true';

      var images = Array.prototype.slice.call(gallery.querySelectorAll('.uc-product-gallery__image'));
      if (images.length < 2) return;

      var current = 0;
      var timer = null;
      var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      function show(index) {
        current = (index + images.length) % images.length;
        images.forEach(function (image, imageIndex) {
          image.classList.toggle('is-active', imageIndex === current);
        });
      }

      function start() {
        if (reducedMotion || timer) return;
        show(1);
        timer = window.setInterval(function () {
          show(current + 1);
        }, 950);
      }

      function stop() {
        if (timer) window.clearInterval(timer);
        timer = null;
        show(0);
      }

      gallery.addEventListener('mouseenter', start);
      gallery.addEventListener('mouseleave', stop);
    });
  }

  if (window.UCProductHover) {
    window.UCProductHover.init(document);
    return;
  }

  window.UCProductHover = { init: init };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
